module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "skip"
  }, [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 1000,
        offset: -50
      }),
      expression: "{ duration: 1000, offset: -50 }"
    }],
    staticClass: "skip--anchor",
    attrs: {
      "href": "#a11y"
    }
  }, [_vm._v("Skip Navigation")])]), _vm._v(" "), _c('app-navigation'), _vm._v(" "), _c('main', {
    staticClass: "content",
    attrs: {
      "role": "main"
    }
  }, [_c('hero'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e3d7cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout.vue
// module id = 86
// module chunks = 0